module.exports = __webpack_public_path__ + "static/media/02keihintouhoku.49e74c76.png";